module.exports = __webpack_public_path__ + "static/img/clickin51.0001f4ff.png";